<template>
  <form class="details upload-form" enctype="multipart/form-data" method="POST">
    <div class="close" v-on:click="close()">
      <b-icon icon="close" size="is-large" />
    </div>
    <b-field class="file">
      <b-upload v-model="file">
        <a class="button is-primary">
          <b-icon icon="upload"></b-icon>
          <span>Choose file</span>
        </a>
      </b-upload>
    </b-field>
    <b-field label="Name">
      <b-input type="text" v-model="name"></b-input>
    </b-field>
    <b-button v-if="hasChanged" @click="save" size="is-large" rounded>{{saveLabel}}</b-button>
  </form>
</template>
<script>
import { mapGetters } from "vuex";
import { saveUpload, renameDownloadFile } from "../api/methods";
import filters from "../mixins/filters";
import { notEmptyString, fileHasChanged } from "../api/helpers";

export default {
  name: "UploadForm",
  components: {},
  props: {
    item: {
      type: Object,
      required: false,
      default() {
        return {
          name: "",
          extension: "",
          size: 0,
          ctime: "",
          mtime: ""
        };
      }
    },
    directory: {
      type: String,
      default: "files"
    }
  },
  mixins: [filters],
  data() {
    return {
      file: null,
      name: "",
      overwrite: false,
      fileChanged: false,
      nameChanged: false
    };
  },
  mounted() {
    this.mapItem();
  },
  computed: {
    ...mapGetters(["user"]),
    hasMatchedFile() {
      let matched = false;
      if (this.item) {
        if (this.item.size) {
          matched = this.item.size > 100;
        }
      }
      return matched;
    },
    hasChanged() {
      return this.nameChanged || this.fileChanged;
    },
    saveLabel() {
      if (this.nameChanged && !this.fileChanged) {
        return "Rename file";
      } else {
        return "Upload file";
      }
    }
  },
  watch: {
    file(cv, pv) {
      if (fileHasChanged(cv, pv)) {
        this.fileChanged = true;
        if (!this.hasMatchedFile) {
          this.name = this.file.name;
        }
      } else {
        this.fileChanged = false;
      }
    },
    name() {
      if (this.hasMatchedFile) {
        this.nameChanged = this.name.trim() !== this.item.name.trim();
      } else {
        this.nameChanged = false;
      }
    }
  },
  methods: {
    mapItem() {
      if (this.item instanceof Object) {
        if (notEmptyString(this.item.name, 4)) {
          this.name = this.item.name;
        }
      }
    },
    save() {
      if (this.file instanceof File) {
        saveUpload(this.user._id, this.directory, this.file, this.name).then(
          data => {
            if (data) {
              this.$parent.mapFiles();
              setTimeout(this.mapItem, 2000);
              this.$buefy.toast.open({
                duration: 4000,
                message: "File uploaded",
                position: "is-bottom",
                type: "is-success"
              });
              setTimeout(this.close, 4000);
            }
          }
        );
      } else if (notEmptyString(this.name)) {
        if (this.name.length > 5 && /^.*?\w.*?\.\w+$/.test(this.name)) {
          if (this.nameChanged) {
            renameDownloadFile(this.user._id, this.item.name, this.name).then(
              data => {
                if (data) {
                  this.$parent.mapFiles();
                  setTimeout(this.mapItem, 2000);
                }
              }
            );
          }
        }
      }
    },
    close() {
      this.$parent.close();
    }
  }
};
</script>